import { toastApp } from '@/components/toast-message/sonner';
import { ViewTransaction } from '@/components/ViewTransaction/ViewTransaction';
import { CONTRACT_TRADING } from '@/constans/trade';
import { DexTrading__factory } from '@/contracts';
import { CONSTANT } from '@/store/constants';
import { getErrorMessage } from '@/utils/get-error';
import { waitForTransactionReceipt } from '@/utils/wait-transaction';
import { MiniKit } from '@worldcoin/minikit-js';
import { t } from 'i18next';
import { mutate } from 'swr';

export async function closePosition(
    pair: number,
    index: number,
    address: string
) {
    const id = 'close';
    try {
        const payload = {
            transaction: [
                {
                    address: CONTRACT_TRADING.TRADING,
                    abi: DexTrading__factory.abi,
                    functionName: 'closeTradeMarket',
                    args: [pair, index],
                },
            ],
        };
        const { finalPayload } = await MiniKit.commandsAsync.sendTransaction(
            payload
        );

        await mutate({ key: 'fetch-balance', address });

        console.log('finalPayload', finalPayload);

        if (finalPayload.status === 'error') {
            throw new Error(finalPayload.error_code);
        }

        toastApp.loading(t('Transaction Submitted'), id);

        const txHash = await waitForTransactionReceipt(
            finalPayload.transaction_id
        );

        const message = (
            <ViewTransaction
                txUrl={`${CONSTANT.URL_SCAN}${txHash}`}
                title={t('Position Closed')}
            />
        );

        toastApp.success(message, id);

        return txHash;
    } catch (error) {
        const errorMessage = getErrorMessage(error);

        toastApp.error(errorMessage, id);
    }
}
